module.exports = __webpack_public_path__ + "static/empty-states-single-empty-states-dont-ed34ae27b5c7e545311fcc17717a6ed3.png";